var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.quillEditor,_vm._b({attrs:{"options":_setup.options},model:{value:(_setup.syncValue),callback:function ($$v) {_setup.syncValue=$$v},expression:"syncValue"}},'quillEditor',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }